import React, { useState, useEffect, useMemo } from "react";
import styled from "@emotion/styled";
import Banner from "./EventBanner.jsx";
import MainInfo from "./mainPlayInfo.jsx";
import Media from "./EventMedia.jsx";
import NavigationTabs from "./NavTabs.jsx";
import StickyButton from "./BookStickyButton.jsx";
import Notice from "./Notice.jsx";
import SummaryContent from "./SummaryContent.jsx";
import { hostName, colors, endpoints } from "../utils/Constants.js";
import { eventGroupCode } from "../utils/Utils.js";
import useOnScreen from "../hooks/useOnScreen.js";

const EventPageInfo = ({
  showModals,
  nullAdditionalInfo,
  producerCount,
  hasEventEnded,
  media,
  mediaLoading,
  venueSeatsProp,
  lat,
  long,
}) => {
  const [loading, setLoading] = useState(true);
  const [eventData, setEventData] = useState({
    banner: [],
    header: [],
    cast: [],
    desc: {},
    fromPrice: {},
    ticketsButtonText: "",
    isStreaming: false,
  });

  const fetchData = () => {
    let lang = $("html").attr("lang");
    let url = endpoints.event.getvalue;

    if (lang) url += "?lang=" + lang;

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        eventCode: eventGroupCode(),
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setEventData({
            desc: result.body,
            banner: result.banner,
            header: result.header,
            cast: result.cast,
            fromPrice: result.fromPrice,
            ticketsButtonText: result.ticketsButtonText,
            isStreaming: result.isStreaming,
          });
          setLoading(false);
        },
        (error) => {
          console.log("cant fetch event values", error);
          setLoading(false);
        },
      );
  };

  useEffect(() => {
    fetchData();
  }, []);

  let navBarThresholdElementId = "r_mainHeader";

  let header = document.getElementById(navBarThresholdElementId);

  const headerVisible = useOnScreen(header);

  function updateDescription(description, additionalText, contentText) {
    setEventData((prev) => ({
      ...prev,
      desc: {
        ...prev.desc,
        description,
        additionalText,
      },
      cast: {
        ...prev.cast,
        contentText,
      },
    }));
  }

  return (
    <div className="RmainEventPage">
      {eventData.banner.metaSEO && (
        <meta itemProp="image" content={eventData.banner.metaSEO} />
      )}

      <Banner
        bannerInfo={eventData.banner}
        title={eventData.header.playTitle}
        loading={loading}
      />

      <MainInfo
        hasEventEnded={hasEventEnded}
        mainInfo={eventData.header}
        loading={loading}
        fromPrice={eventData.fromPrice}
        ticketsButtonText={eventData.ticketsButtonText.toString()}
        venueSeatsProp={venueSeatsProp}
        lat={lat}
        long={long}
        headerVisible={headerVisible}
        isStreaming={eventData.isStreaming}
      />

      <NavigationTabs
        context={"Event"}
        pageInfoProp={{
          showModals,
          nullAdditionalInfo,
          producerCount,
          hasEventEnded,
        }}
        hasMedia={media.length > 0}
        buttonText={eventData.ticketsButtonText}
        venueSeatsProp={venueSeatsProp}
        loading={loading}
        headerVisible={headerVisible}
      />

      <SummaryContent
        desc={eventData.desc}
        cast={eventData.cast}
        loading={loading}
        context={"Event"}
        updateDescription={updateDescription}
      />

      <Media mainUrl={hostName} media={media} loading={mediaLoading} />

      <Notice desc={eventData.desc} loading={loading} />

      {!hasEventEnded && !loading && (
        <StickyButton
          context={"Event"}
          buttonText={eventData.ticketsButtonText.toString()}
          venueSeatsProp={venueSeatsProp}
          headerVisible={headerVisible}
        />
      )}
    </div>
  );
};

export default EventPageInfo;
